import { useEffect, useState } from "react";

import gtl from "@gaming/gtl";

import { siteLocationPrefix } from "../constants";
import { RouteNames } from "../partnerConfig/routeNames";
import { OnboardingUrls } from "../partnerConfig/routes";
import { OnboardingPageName } from "./models";

// The format for url is actually just the path without host nor locale. i.e: '/publish/program-selection'
export const logPageView = (url: string) => {
  try {
    gtl.writePageView(getPageName(url), url);
  } catch (error) {}
};

export const useLogPageView = () => {
  const [isLogged, setIsLogged] = useState(false);
  useEffect(() => {
    if (!isLogged) {
      setIsLogged(true);
      const url = new URL(window.location.href);
      logPageView(url.pathname.substring(6));
    }
  }, [isLogged]);
};

export const getPageName = (url: string): string => {
  switch (url) {
    case OnboardingUrls[RouteNames.Landing]:
      return OnboardingPageName.Landing;
    case OnboardingUrls[RouteNames.ProgramSelection]:
      return OnboardingPageName.ProgramSelection;
    case OnboardingUrls[RouteNames.IdXboxGameInfoDashboard]:
      return OnboardingPageName.IdXboxDashboard;
    case OnboardingUrls[RouteNames.IdXboxWelcome]:
      return OnboardingPageName.WelcomePartner;
    case OnboardingUrls[RouteNames.IdXboxFormPreview]:
      return OnboardingPageName.FormPreview;
  }

  if (url.startsWith(`${siteLocationPrefix}/id/introduction`)) {
    return OnboardingPageName.IntroductionForm;
  }

  if (url.startsWith(`${siteLocationPrefix}/id/game-information`)) {
    return OnboardingPageName.GameInformationForm;
  }

  return "Unknown";
};
